import React from 'react'
import Search from './Search'
import DisabledBigButton from './DisabledBigButton'
import disabledAddIcon from '../images/disabledAddIcon.svg'
import disabledUploadIcon from '../images/disabledUploadIcon.svg'

class HeaderTicketComponent extends React.Component {
  uploadCsv () {
    console.log("UPLOAD")
  }

  addTicket () {
    console.log("ADD TICKET")
  }

  render () {
    return (
      <div style={styles.content}>
        <div style={styles.top}>
          <div style={styles.titleContent}>
            <span style={styles.title}>{this.props.title}</span>
          </div>
          <Search
            getKeySearch={this.props.getKeySearch}
          />
        </div>
        <div>
          <DisabledBigButton
            // link={`/${localStorage.getItem('endpoint')}/upload-csv`}
            label='UPLOADER UN CSV'
            img={disabledUploadIcon}
            onClick={() => this.uploadCsv()}
          />
          <DisabledBigButton
            // link={`/${localStorage.getItem('endpoint')}/add-ticket`}
            label='AJOUTER UN TICKET'
            img={disabledAddIcon}
            onClick={() => this.addTicket()}
          />
        </div>
      </div>
    )
  }
}

const styles = {
  content: {
    height: '100px',
    marginTop: '5px'
  },
  top: {
    height: '50px'
  },
  titleContent: {
    float: 'left'
  },
  title: {
    float: 'left',
    marginTop: '3px',
    marginLeft: '14px',
    fontSize: '32px',
    color: '#FFFFFF',
    fontWeight: 321,
    fontStyle: 'normal'
  }
}

export default HeaderTicketComponent
